import { getTranslations } from '../translate';
import css from './loadingIndicator.module.less';
import { CircularProgress } from '@mui/material';
import c from 'classnames';
import { HTMLProps, ReactNode, useEffect, useState } from 'react';

interface LoadingIndicatorProps extends Omit<HTMLProps<HTMLDivElement>, 'label' | 'size'> {
    hideSymbol?: boolean;
    center?: boolean | 'horizontal';
    label?: ReactNode | boolean;
    noMargin?: boolean;
    size?: number | string;
    thickness?: number;
    color?: string;
    showWithDelay?: number;
}

export default function LoadingIndicator({
    className,
    center = true,
    label,
    size,
    noMargin,
    thickness,
    color,
    showWithDelay,
    ...divProps
}: LoadingIndicatorProps) {
    const showMargin = !noMargin;

    const [show, setShow] = useState(!showWithDelay);

    useEffect(() => {
        if (!showWithDelay) {
            return;
        }

        const timeout = setTimeout(() => {
            setShow(true);
        }, showWithDelay);

        return () => clearTimeout(timeout);
    }, [showWithDelay]);

    if (!show) {
        return null;
    }

    return (
        <div
            className={c(className, css.view, {
                [css.centerHorizontal]: center === true || center === 'horizontal',
                [css.centerVertical]: center === true,
                [css.showMargin]: showMargin,
            })}
            {...divProps}
        >
            <CircularProgress
                className={css.spinner}
                size={size ?? (label ? '0.8rem' : '2rem')}
                thickness={thickness ?? (label ? 5 : undefined)}
                style={{ color: `${color ?? ''}` }}
                variant="indeterminate"
            />
            {label && (
                <span className={css.label} style={{ color }}>
                    {label === true ? getTranslations().t('loading') : label}
                </span>
            )}
        </div>
    );
}
